import { render, staticRenderFns } from "./CartSidebar.vue?vue&type=template&id=c8226f52"
import script from "./CartSidebar.vue?vue&type=script&lang=js"
export * from "./CartSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports